import {PolIcon} from "components/PolIcon/policon";
import moment from "moment";
import React, {useCallback} from 'react';
import {Link} from "react-router-dom";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {getFieldsValuesByKey} from "v4/utils";
import getDatetimeFormat from "v4/utils/getDatetimeFormat";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import TextareaRenderer from "v4/components/form/ShowField/components/TextareaRenderer/TextareaRenderer";


export default function TimelineItem({task}) {
    const {t} = usePolTranslation();
    const { getRouteByNativeIdentifier, currentRoute } = useNavigation();

    const classSuffixPosition = useCallback((statusComparison) => [statusComparison].flat().includes(getFieldsValuesByKey('status', task))
            ? 'right'
            : 'left'
        , [task]);

    const getItemURL = useCallback((metadata) => {
        const {id, isMailing, isSynchroOutlook, isClosed} = metadata;
        let identifier = 'detail_open_tasks';

        if (isMailing) identifier = 'detail_mail_history';
        else if (isSynchroOutlook) identifier = 'detail_received_mails';
        else if (isClosed) identifier = 'detail_closed_tasks';

        const route = getRouteByNativeIdentifier(identifier);
        return `/${resolveUrl(route?.url, { prospect: currentRoute.params.prospect })}/${id}`;
    }, [getRouteByNativeIdentifier, currentRoute.params.prospect]);

    return (
        <div className="summaryTask__timeline">
            <div
                className={`summaryTask__timeline__state summaryTask__timeline__state--${getFieldsValuesByKey('status', task)}`}>
                <PolIcon icon="clock"/>
            </div>
            <div
                className={`summaryTask__timeline__content summaryTask__timeline__content--${classSuffixPosition('late')}`}>
                <div className="summaryTask__timeline__content__title">
                    <Link to={getItemURL(task.metadata)}>
                        {t(getFieldsValuesByKey('taskType', task))}
                        <PolIcon className="ml-2" icon="eye"/>
                    </Link>
                </div>
                <div className="summaryTask__timeline__content__info">
                    <div className="summaryTask__timeline__content__info--title">
                        <div>
                            <span>{getFieldsValuesByKey('name', task)}</span>
                            {getFieldsValuesByKey('contact', task) && t('tasks_summary_contacts_to')}
                            <span>{getFieldsValuesByKey('contact', task)}</span>
                        </div>
                        <div>{getFieldsValuesByKey('managedBy', task)}</div>
                    </div>
                    <div className="summaryTask__timeline__content__info--text">
                        {getFieldsValuesByKey('report', task)
                            ? (
                                <div className="summaryTask__timeline__content__info--report resizable-v">
                                    <div>{t('compte_rendu')}</div>
                                    <TextareaRenderer value={getFieldsValuesByKey('report', task)} formMetadata={task.metadata}/>
                                </div>
                            )
                            : null
                        }
                        {getFieldsValuesByKey('memo', task)
                            ? (
                                <div className="summaryTask__timeline__content__info--memo resizable-v">
                                    <div>{t('memo')}</div>
                                    <TextareaRenderer value={getFieldsValuesByKey('memo', task)} formMetadata={task.metadata}/>
                                </div>
                            )
                            : null
                        }
                        {(!getFieldsValuesByKey('report', task) && !getFieldsValuesByKey('memo', task))
                            ? (
                                <div className="summaryTask__timeline__content__info--none">
                                    <div>{t('no_additional_information')}</div>
                                </div>
                            )
                            : null
                        }
                    </div>
                </div>
            </div>
            <div
                className={`summaryTask__timeline__content--date summaryTask__timeline__content--date--${classSuffixPosition(['ongoing', 'closed'])}`}>
                <div>
                    {getFieldsValuesByKey('beginAt', task) ? moment(getFieldsValuesByKey('beginAt', task)).format(getDatetimeFormat()) : ''}
                </div>
            </div>
        </div>
    )
}

